
/**
 * @export
 * @enum {string}
 */
export enum AdminSortField {
    EMAIL = 'EMAIL',
    LAST_NAME = 'LAST_NAME',
    FIRST_NAME = 'FIRST_NAME',
    JOB_TITLE = 'JOB_TITLE',
    STATUS = 'STATUS'
}